<template>
  <div class="group-fields-container">
    <!-- 可用字段区域 -->
    <div class="available-fields">
      <span class="fields-label">可用字段:</span>
      <draggable :list="availableFields"
                 :group="{ name: 'shared-fields', pull: 'clone', put: true }"
                 :clone="cloneField"
                 class="fields-list"
                 :sort="true">
        <div v-for="item in availableFields" :key="item.value"
        >
          <div class="field-item">

            <el-tag style="margin: 5px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                 border: none; color: white; border-radius: 15px; padding: 4px 12px;
                 font-weight: 500; cursor: move;">
              {{ item.label }}
            </el-tag>

          </div>
        </div>
      </draggable>


    </div>

    <!-- 分组字段区域 -->
    <div class="group-area">
      <span class="group-label">分组字段:</span>
      <draggable
          v-model="checkedYugu"
          tag="div"
          class="drag-container"
          :group="{ name: 'shared-fields', pull: true, put: true }"
          :animation="200"
          item-key="value"
          style="display: flex; align-items: center; min-height: 30px; margin-left: 15px; flex-wrap: wrap;"
          @add="onAdd"
      >
        <div v-for="item in checkedYugu" :key="item"
        >
          <el-tag
              closable
              :disable-transitions="false"
              @close="handleClose" style="margin: 5px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                   border: none; color: white; border-radius: 15px; padding: 4px 12px;
                   font-weight: 500; cursor: move;"
          >
            {{ getFieldLabel(item) }}
          </el-tag>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>

import draggable from 'vuedraggable'

export default {
  computed: {},
  components: {draggable},
  data() {
    return { // 可用的分组字段
      availableFields: [
        {value: '品类', label: '品类'},
        {value: '游戏名', label: '游戏名'},
        {value: '日期', label: '日期'}
      ],
      checkedYugu: ['品类', '游戏名'],
      dialog: false,
      loading: false,
      value2: '',
      form: {
        name: '',
        password: ''

      },
      formLabelWidth: '80px',
      timer: null,
      tableData: []

    };
  },
  methods: { // 获取字段标签显示文本
    getFieldLabel(value) {
      const field = this.availableFields.find(f => f.value === value);
      return field ? field.label : value;
    },
    cloneField(field) {
      console.log("克隆字段", field);
      return field.value; // 返回字段的 value 值
    }, // 关闭标签（从分组区域移除）
    handleClose(value) {
      const index = this.checkedYugu.indexOf(value);
      if (index > -1) {
        this.checkedYugu.splice(index, 1);
      }
    },
    onAdd(evt) {

      console.log("添加字段", evt.item.textContent);
    },
    // 对数函数拟合和R²计算
    logarithmicRegression(xData, yData) {
      // 过滤掉x为0或负数的点（对数函数定义域）
      const validPoints = xData.map((x, i) => ({x, y: yData[i]}))
          .filter(point => point.x > 0 && !isNaN(point.x) && !isNaN(point.y));

      const n = validPoints.length;
      if (n < 2) return null;

      // 计算ln(x)值
      const lnX = validPoints.map(point => Math.log(point.x));
      const y = validPoints.map(point => point.y);

      // 计算拟合参数 a*ln(x) + b
      const sumLnX = lnX.reduce((a, b) => a + b, 0);
      const sumY = y.reduce((a, b) => a + b, 0);
      const sumLnX2 = lnX.reduce((a, b) => a + b * b, 0);
      const sumLnXY = lnX.reduce((sum, lx, i) => sum + lx * y[i], 0);

      const a = (n * sumLnXY - sumLnX * sumY) / (n * sumLnX2 - sumLnX * sumLnX);
      const b = (sumY - a * sumLnX) / n;

      // 计算R²
      const yMean = sumY / n;
      const ssTot = y.reduce((sum, yi) => sum + Math.pow(yi - yMean, 2), 0);
      const ssRes = y.reduce((sum, yi, i) => {
        const yPred = a * lnX[i] + b;
        return sum + Math.pow(yi - yPred, 2);
      }, 0);

      const rSquared = 1 - (ssRes / ssTot);

      return {
        a: a,
        b: b,
        equation: `y = ${a.toFixed(4)}*ln(x) + ${b.toFixed(4)}`,
        rSquared: rSquared
      };
    },

    test() {

      // 使用示例
      const ad_roi = [1, 2, 3, 4, 5, 6, 7, 15]; // ad_roi1-ad_roi7的x值
      const yValues = [24.87, 30.58, 32.01, 33.29, 34.77, 36.55, 38.65, 51.23];

      const result = this.logarithmicRegression(ad_roi, yValues);
      console.log('拟合方程:', result.equation);
      console.log('R²:', result.rSquared);
    }

  },
  mounted() {

    console.log('Available fields:', this.availableFields);
    console.log('Checked yugu:', this.checkedYugu);
  },


}
</script>

